import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { UniversalLink } from '@plone/volto/components';
import { RichTextArticle } from 'design-comuni-plone-theme/components/ItaliaTheme/View';

const PersonaUnitaOrganizzativa = ({ content }) => {
  const intl = useIntl();
  const UO = content?.organizzazione_riferimento;

  const showSection = content?.organizzazione_riferimento?.length > 0;

  return showSection ? (
    <RichTextArticle
      tag_id="unita_organizzativa"
      title={intl.formatMessage(messages.unita_organizzativa)}
    >
      {UO?.map((uo) => {
        return (
          <div className="mb-5">
            <UniversalLink href={uo['@id']}>{uo.title}</UniversalLink>
          </div>
        );
      })}
    </RichTextArticle>
  ) : (
    <></>
  );
};
export default PersonaUnitaOrganizzativa;

const messages = defineMessages({
  unita_organizzativa: {
    id: 'unita_organizzativa',
    defaultMessage: 'Unità organizzativa',
  },
});
